/** The media itself uses object-contain; extreme ratios get letterboxing. */
export function referencePreviewSize(width: number, height: number) {
  if (width <= 0 || height <= 0) return { width: 200, height: 200 }
  const scale = 200 / Math.max(width, height)
  return {
    width: Math.max(72, Math.round(width * scale)),
    height: Math.max(72, Math.round(height * scale)),
  }
}
